import * as Yup from 'yup';

export const schema = Yup.object().shape({
  QNH: Yup.number().required('Required'),
  QFR: Yup.number(),
});
